import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFilterParams } from '@/lib/utils'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type {
  Contract,
  ContractDefaults,
  CreateContractInput,
  CreatedContract,
} from './contracts.types'

/** The organization every contract request and query key carries. */
export interface ContractKeyEntries {
  organizationId: OrganizationId
}

export interface ContractIndexKeyEntries extends ContractKeyEntries {
  filters?: QueryFilterParams | undefined
}

/** Query functions read only the key. */
type ContractQueryContext<TKey> = Pick<QueryFunctionContext<[TKey]>, 'queryKey'>

export async function getContracts({
  queryKey: [{ organizationId, filters = {} }],
}: ContractQueryContext<ContractIndexKeyEntries>) {
  return (
    (await axios.get<Contract[]>(
      '/contracts',
      buildAdminRequestConfig({ organizationId, params: { ...filters } })
    )) || []
  )
}

export async function createContract({
  organizationId,
  ...values
}: CreateContractInput & { organizationId: number }) {
  return axios.post<CreatedContract>(
    '/contracts',
    values,
    buildAdminRequestConfig({ organizationId })
  )
}

export async function getContractDefaults({
  queryKey: [{ organizationId }],
}: ContractQueryContext<ContractKeyEntries>) {
  return axios.get<ContractDefaults>(
    '/contracts/defaults',
    buildAdminRequestConfig({ organizationId })
  )
}
